import React, { useEffect } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import LazyImage from "../../shared/lazy-image";
import faqFormatter from "../../../utils/helpers/faq-formatter";
import {STEPS} from "./constants";
import { NUMBER } from "../../../constants/app-constants";

const WhyCars = ({
    isSSR,
    fetchDataConnect,
    faqs,
    setFaqs,
    slug = "seller-common-homepage",
    fetchFAQConnect,
    isSellerHomepage = false,
    genericContent = {},
    tweets = [],
    apiPayload = {}
}) => {

    const { content = "" } = genericContent || {};
    const tweetsLength = (tweets || []).length;

    useEffect(() => {
        if (!isSSR && tweetsLength === NUMBER.ZERO) {
            const payload = {
                ...(apiPayload || {}),
                expand: ["tweets", ...(apiPayload && apiPayload.expand || [])].toString()
            };
            fetchDataConnect(payload);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchDataConnect, isSSR, tweetsLength]);

    useEffect(() => {
        if (faqs && !faqs.length) {
            const faqPayload = {
                slug
            };
            fetchFAQConnect(faqPayload)
                .then(response => {
                    const list = faqFormatter(response);
                    setFaqs(list);
                });
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [faqs]);

    return (
        <div styleName={"styles.whyCars"}>
            <h2>Why sell car to CARS24?</h2>
            {(isSellerHomepage && content) &&
                <div
                    styleName={"styles.cmsTextWrapper"}
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            }
            <ul>
                {
                    STEPS.map(({img, title, subTitle, description}) => (
                        <li key={title}>
                            <LazyImage src={img} alt={title} width="70px" height="70px" />
                            <div styleName={"styles.whyCarsText"}>
                                <h3>{title}</h3>
                                <h3>{subTitle}</h3>
                                <p>{description}</p>
                            </div>
                        </li>
                    ))
                }
            </ul>
        </div>
    );
};

WhyCars.propTypes = {
    isSSR: PropTypes.bool,
    fetchDataConnect: PropTypes.func,
    faqs: PropTypes.array,
    setFaqs: PropTypes.func,
    slug: PropTypes.string,
    fetchFAQConnect: PropTypes.func,
    isSellerHomepage: PropTypes.bool,
    genericContent: PropTypes.object,
    tweets: PropTypes.array,
    apiPayload: PropTypes.object
};

export default WhyCars;
